import React, { useState, useEffect } from "react";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";
import Style from "./Acounting.module.css";
import { separate } from "../../Functions/NumberSeprator";
import { getAcountinListApi, getWalletApi } from "../../Api/SupplierServices";
import { cashOutFoodApi } from "../../Api/BarestSupplierServices";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import moment from "jalali-moment";
const Acounting = () => {
  const [data, setData] = useState([]);
  const [amountWallet, setAmountWallet] = useState([]);
  const [filter, setFilter] = useState(0);

  useEffect(() => {
    getAcountingInfo();
    getWallet();
  }, []);
  //////////لیست ریز تراکنش ها ////////////////
  const getAcountingInfo = async () => {
    const result = await getAcountinListApi();
    result.transactions.sort((a,b) => {
      if (parseInt(a.id) > parseInt(b.id)) {
        return -1;
      }
    })
    setData(result.transactions)
  };
  //////////////گرفتن موجودی کیف پول //////////////////
  const getWallet = async () => {
    const result = await getWalletApi();
    setAmountWallet(result.wallet);
  };
  ////////// هندل کردن قسمت فیلتر واریزی و برداشتی ////////////////
  const SetFilterOnAmountList = (id) => {
    if (id === 0) {
      setFilter(0);
    } else if (id === 1) {
      setFilter(1);
    } else if (id === 2) {
      setFilter(2);
    }
  };
  ///////////درخواست برداشت //////////////////
  const requestCash = () => {
    let info = {
      cashout: true,
    };
    cashOutFoodApi(info, (res) => {
      if (res.status === 1) {
        succToast(res.message);
      } else {
        errorToast(res.message);
      }
      getWallet();
    });
  };
  return (
    <div className={Style.pageHolder}>
      <MenuTitle title={"حسابداری"} />
      <div className={Style.center}>
        <div className={Style.amountAcountPart}>
          <div className={Style.amountAcount}>
            موجودی حساب:
            <span className={Style.price}>
              {amountWallet ? separate(amountWallet) : 0} تومان{" "}
            </span>
          </div>
          <button onClick={requestCash} className={Style.btnGet}>
            برداشت
          </button>
        </div>
        <div className={Style.filterPart}>
          <div
            className={filter === 0 ? Style.eachFilterSelect : Style.eachFilter}
            onClick={() => SetFilterOnAmountList(0)}
          >
            همه
          </div>
          <div
            className={filter === 1 ? Style.eachFilterSelect : Style.eachFilter}
            onClick={() => SetFilterOnAmountList(1)}
          >
            واریزی ها
          </div>
          <div
            className={filter === 2 ? Style.eachFilterSelect : Style.eachFilter}
            onClick={() => SetFilterOnAmountList(2)}
          >
            برداشتی ها
          </div>
        </div>
        <div className={Style.holder}>
          {data
            .filter((value) => {
              if (filter === 2) {
                return value.amount < 0;
              } else if (filter === 1) {
                return value.amount > 0;
              } else if (filter === 0) {
                return value;
              } else return false;
            })
            .map((item, index) => {
              return (
                <div
                  key={index}
                  className={
                    item.amount < 0 ? Style.eachItemOut : Style.eachItemIn
                  }
                >
                  <h2 style={{ fontSize: ".7rem" }}>
                    {" "}
                    شماره تراکنش:{" "}
                    <span className={Style.details}>{separate(item.id)} </span>
                  </h2>
                  {
                    item.track_id?<h2 style={{ fontSize: ".7rem" }}>
                    {" "}
                     کد پیگیری :{" "}
                    <span className={Style.details}>{item.track_id} </span>
                  </h2>:null
                  }
                  {item.amount > 0 ? (
                    <h2 style={{ fontSize: ".7rem" }}>
                      {" "}
                      شماره سفارش:{" "}
                      <span className={Style.details}>
                        {separate(item.order_id)}{" "}
                      </span>
                    </h2>
                  ) : null}
                  {item.amount < 0 ? (
                    <h2 style={{ fontSize: ".7rem" }}>
                      {" "}
                      کارمزد:{" "}
                      <span className={Style.details}>
                        {separate(item.wage)}{" "}
                      </span>
                    </h2>
                  ) : null}
                  <h2 style={{ fontSize: ".7rem" }}>
                    مقدار:{" "}
                    <span className={Style.details}>
                      {separate(item.amount)}{" "}
                    </span>
                    تومان
                  </h2>
                  <h2 style={{ fontSize: ".7rem" }}>
                    تاریخ :{" "}
                    <span className={Style.details}>
                      {moment.unix(parseInt(item.date, 10)).format('jYYYY/jMM/jDD HH:mm')}{" "}
                    </span>
                  </h2>
                    {
                      item.withdraw_date?                  <h2 style={{ fontSize: ".7rem" }}>
                      تاریخ واریز :{" "}
                      <span className={Style.details}>
                        {moment.unix(parseInt(item.withdraw_date, 10)).format('jYYYY/jMM/jDD HH:mm')}{" "}
                      </span>
                    </h2>:null
                    }

                </div>
              );
            })}
        </div>

        {/* <div className={Style.picHolder}>
                    <img src={"/Assets/Images/acounting/acount.png"} alt=""/>
                </div>
                <section className={Style.allInfo}>
                    <div className={Style.sellAcountPart}>
                        <h3 className={Style.sellAcountText}>محاسبه مقدار فروش</h3>
                        <div className={Style.AllOrderPart}>
                            <span className={Style.number}> <h3 className={Style.num}>عدد</h3> {data.count}</span>
                            <h3 className={Style.allOrderText}>:کل سفارش ها</h3>
                        </div>
                        <div className={Style.priceAllOrder}>
                            <span className={Style.priceNum}><h3>تومان</h3>{separate(data.income)} </span>
                            <h3 className={Style.orderPrice}>:مبلغ کل سفارش ها</h3>
                        </div> 
                    </div>    
                    <div className={Style.comisionPart}>
                        <h3 className={Style.comisionText}>محاسبه مقدار کمیسیون بَرِست </h3>
                        <div className={Style.comisionPricePart}>
                            <h3>:مبلغ کل کمیسیون</h3>
                            <span className={Style.comisionPrice}> <h3>تومان</h3>{separate(data.commission)} </span>
                        </div>
                        <div className={Style.karmozdPart} style={{marginTop:"1rem"}}>
                            <h3 className={Style.karmozdText}>:مبلغ کارمزد برداشت</h3>
                            <span className={Style.karmozdPrice}><h3>تومان</h3>{separate(data.commission1)}</span>
                        </div>
                    </div>   
                    <Button ClassBtn={"confirmBtn"} Value={"برداشت"}/> 
                </section> */}
      </div>
    </div>
  );
};

export default Acounting;
